import MicroModal from 'micromodal';

import embedYoutube from './youtube-player';
import embedVimeo from './vimeo-player';

const selectors = {
  videoPopup: '[data-video-popup]',
  videoAutoplay: '[data-video-autoplay]',
  attrUnique: 'data-unique',
  attrVideoId: 'data-video-id',
  attrVideoType: 'data-video-type',
  attrPlayer: 'data-player',
};

class PopupVideo {
  constructor(section) {
    this.container = section.container;
    this.triggers = this.container.querySelectorAll(selectors.videoPopup);
    this.backgroundVideo = this.container.querySelector(selectors.videoAutoplay);

    this.init();
  }

  init() {
    this.triggers.forEach((trigger) => {
      const unique = trigger.getAttribute(selectors.attrUnique);
      const video = trigger.getAttribute(selectors.attrVideoId);
      const type = trigger.getAttribute(selectors.attrVideoType);

      // Find the modal body, which has been moved to the document root
      // and append a unique ID for youtube and vimeo to init players.
      const uniqueKey = `${video}-${unique}`;
      const player = document.querySelector(`[${selectors.attrPlayer}="${uniqueKey}"]`);

      // Modal Event Logic:
      // When a modal opens it creates and plays the video
      // When a modal opens it pauses background videos in this section
      // --
      // When a modal closes it destroys the player
      // When a modal closes it plays background videos anywhere on the page
      MicroModal.init({
        onShow: () => {
          if (this.backgroundVideo && typeof this.backgroundVideo.pause === 'function') {
            this.backgroundVideo.pause();
          }
          let playerPromise = {};
          if (type === 'youtube') {
            playerPromise = embedYoutube(uniqueKey);
          } else if (type === 'vimeo') {
            playerPromise = embedVimeo(uniqueKey);
          }
          playerPromise.then(() => {
            player.dispatchEvent(new CustomEvent('play'));
          });
        },
        onClose: (modal, el, event) => {
          event.preventDefault();
          player.dispatchEvent(new CustomEvent('destroy'));
          if (this.backgroundVideo && typeof this.backgroundVideo.play === 'function') {
            this.backgroundVideo.play();
          }
        },
        openTrigger: `data-trigger-${video}-${unique}`,
      });
    });
  }
}

const popupVideoSection = {
  onLoad() {
    new PopupVideo(this);
  },
};

export default popupVideoSection;
